import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './Update.module.less';

import { PCStoreJsBridge } from '../../../nativeapi';
import { logging } from '../../../actions/log';
import Toast from '../../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  // 是否打开自动升级商店
  const [isEnableInd, setIsEnableInd] = useState(true);
  const handleChoose = useCallback(() => {
    PCStoreJsBridge.setAppStoreSwitch({
      type: 11,
      enable: !isEnableInd,
      source: 1,
    }).then(res => {
      if (res.code !== 0 || !res.succ) {
        setIsEnableInd(isEnableInd);
        Toast.error({
          content: '设置失败！',
        });
      } else {
        setIsEnableInd(!isEnableInd);
        Toast.success({ content: '设置成功！', duration: 2 });
      }
      if (isEnableInd) {
        dispatch(
          logging({
            category: 'C',
            action: 'Tankuang_Enabled',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              enabled: false,
              type: 11,
            },
          }),
        );
      } else {
        dispatch(
          logging({
            category: 'C',
            action: 'Tankuang_Enabled',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              enabled: true,
              type: 11,
            },
          }),
        );
      }
    });
  }, [isEnableInd]);

  // 修改未知文件设置的默认值
  useEffect(() => {
    PCStoreJsBridge.getAppStoreSwitch({
      type: 11,
      source: 1,
    }).then(res => {
      if (res.succ) {
        setIsEnableInd(res.enable);
      }
    });
  }, []);

  return (
    <div className={styles.s_update}>
      <div className="s_line">
        <div className="s_select_title">个性化推荐：</div>
        <div className="s_content">
          <div className="checkbox" onClick={handleChoose}>
            {isEnableInd ? <div className="checked" /> : <div className="no_checked" />}
            <span>开启个性化内容推荐</span>
          </div>
          <div className="desc">建议开启，开启后会看到更多您更感兴趣的内容</div>
        </div>
      </div>
    </div>
  );
});
